/** The three limit states as one chip: an icon and a word (✓ Clear, ▲ Watch, ● Flag), so no state rests on colour alone. */
import { GxPill, type PillTone } from "./GxPill";
import "./forecast-marks.css";

export type LimitState = "clear" | "watch" | "flag";
const MARK: Readonly<Record<LimitState, string>> = { clear: "✓", watch: "▲", flag: "●" };
export const STATE_WORD: Readonly<Record<LimitState, string>> = { clear: "Clear", watch: "Watch", flag: "Flag" };
/** Worst first. */
export const STATE_RANK: Readonly<Record<LimitState, number>> = { flag: 0, watch: 1, clear: 2 };

const TONE: Readonly<Record<LimitState, PillTone>> = { clear: "good", watch: "warn", flag: "crit" };

export function GxStateChip({ state, testId }: { readonly state: LimitState; readonly testId?: string }) {
  return <GxPill tone={TONE[state]} {...(testId === undefined ? {} : { testId })}><span aria-hidden="true">{MARK[state]}</span>{STATE_WORD[state]}</GxPill>;
}
